import WaitingListTableWrapper from './WaitingListTableWrapper.component';

export default WaitingListTableWrapper;
